import { render, staticRenderFns } from "./NotificationsSection.vue?vue&type=template&id=103949f4"
import script from "./NotificationsSection.vue?vue&type=script&lang=js"
export * from "./NotificationsSection.vue?vue&type=script&lang=js"
import style0 from "./NotificationsSection.vue?vue&type=style&index=0&id=103949f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports